<template>
    <pm-custom-dialog v-if="visible" v-model="visible" style="z-index: 999999999999;">

        <div v-if="trialExtended == 0" style="padding: 0 30px; text-align: center;">


            <h3 style="line-height: 1.2; font-weight: 800; text-shadow: 0px 0px 0 #000; margin: 20px 0 20px 0;">
                Your trial has been expired
            </h3>

            <p style="line-height: 1.3; font-size: 15px; margin-bottom: 8px;">
                Enter your email address and you'll <b style="font-weight: 600;">get<br/>extra {{extraTrialDays}} days free</b> trial of DentiCalc.
            </p>

            <br/>
            <div style="display: flex; justify-content: center; align-items: center; flex-direction: column; width: 100%;">
                <v-text-field style="width: 100%;" type="email" ref="reviewEmail" box id="feedback-email-input" v-model="email" :placeholder="$t('support.email')" />

                <v-btn class="blue" style="padding: 0 24px 0 32px; background: #fff; height: 48px!important; border-radius: 16px; border: 1px solid #2962ff; box-shadow: 0 0 6px rgba(0,0,0,.18); color: #fff;" large :loading="processing" @click="send">
                    <span style="text-transform: uppercase!important; line-height: 1; padding-right: 16px; font-weight: 600;">
                        GIVE ME {{extraTrialDays}} EXTRA DAYS
                    </span>
                    <v-icon style="margin-top: -2px;">chevron_right</v-icon>
                </v-btn>

                <br/>

                <span style="font-size: 14px;">
                    We value your <router-link to="/privacy-policy" v-on:click.native="visible=false">privacy.</router-link>
                </span>


            </div>
        </div>

        <div v-if="trialExtended > 0">
            <img src="https://cdn.denticalc.com/images/app-success-2.jpg" style="max-width: 90%;" />
            <br/>
            <span style="font-size: 40px; font-weight: 600; color: green;">+ {{ trialExtended }} days</span>
            <h2 style="margin-top: 20px; font-size: 16px; font-weight: 600; text-transform: uppercase;">Your trial has been<br/>successfully extended</h2>
            <br/><br/>
            <v-btn style="border-radius: 16px;" large class="grey lighten-3" @click="reload">
                <span style="text-transform: uppercase!important;">
                    CLOSE <v-icon style="margin-top: -2px;">chevron_right</v-icon>
                </span>
            </v-btn>
        </div>

    </pm-custom-dialog>
</template>
<script>
import PmCustomDialog from "./base-dialog.vue";
import { callSlackWebhook } from "@/utils/webhooks/slack";
import { trialDaysLeft } from "@/utils/iap/trial-days";
import { trialConfig } from "@/configs/trial";

export default {
    components: {
        PmCustomDialog
    },
    data: () => ({
        visible: false,
        email: localStorage.getItem('userEmailSend') || localStorage.getItem('userEmail') || "",
        trialExtended: 0,
        extraTrialDays: trialConfig.extraTrialDays,
    }),
    created() {
        this.$bus.$on('extra-trial-offer-dialog:show', () => {
            this.show();
        });
    },
    watch: {
        email() {
            // Store own email
            localStorage.setItem("userEmailSend", this.email);
        },
    },
    methods: {
        reload() {
            this.visible = false;
            this.$bus.$emit('trialExtended');
            this.$emit('close');
        },
        show() {
            if (localStorage.getItem('extendedTrial') !== null) return;
            if (window.IAP.hasPremiumAccess()) return;
            this.visible = true;

            window.Tracker.logEvent({
                event_name: "extra_trial_offer",
                event_category: "iap",
                event_label: "show",
            });
        },
        validateEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        send() {
            window.Tracker.logEvent({
                event_name: "extra_trial_offer",
                event_category: "iap",
                event_label: "send",
            });
            if (!this.validateEmail(this.email)) {
                this.$refs.reviewEmail.focus();
                return;
            }
            callSlackWebhook("#denticalc-registrations", "New subscriber (trial extended): " + this.email);
            this.trialExtended = this.extraTrialDays;
            const duration = trialDaysLeft() + this.extraTrialDays;
            this.extendTrial({duration: duration});
            this.$bus.$emit('flutter:updateFirstRunTS');
            window.Tracker.logEvent({
                event_name: "extra_trial_offer",
                event_category: "iap",
                event_label: "success",
            });
        },
        extendTrial(result) {
            const date = new Date();
            date.setDate(date.getDate() + result.duration);

            if (typeof result.sku === "string") {
                localStorage.setItem('ca_' + result.sku, String(date.getTime()))
            } else {
                localStorage.setItem('extendedTrial', String(date.getTime()));
            }
        },

    }
}
</script>
